import React from 'react';

const SvgChevron = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 20" {...props}>
    <path d="m.5 10 9.52 10 1.48-1.667L3.673 10 11.5 1.667 10.02 0 .5 10Z" />
  </svg>
);

export default SvgChevron;
